// extracted by mini-css-extract-plugin
export default {"preview-container":"external-url-drag-preview-item__preview-container--edabC","previewContainer":"external-url-drag-preview-item__preview-container--edabC"};